// 声明文件
const YESTERDAY = 'yesterday_data';
const SEVEN = 'near_seven_data';
const THIRTY = 'near_thirty_data';
const YEAR = 'near_year_data';
import i18n from '@/i18n/index.js';

// 单位
export const NUMBER_UNITS = () => [
  i18n.t('HT.numberUnits.unit'),
  i18n.t('HT.numberUnits.unit'),
  i18n.t('HT.numberUnits.unit2'),
  i18n.t('HT.numberUnits.unit3'),
  i18n.t('HT.numberUnits.unit4'),
  i18n.t('HT.numberUnits.unit5'),
  i18n.t('HT.numberUnits.unit6'),
  i18n.t('HT.numberUnits.unit7'),
  i18n.t('HT.numberUnits.unit8'),
  i18n.t('HT.numberUnits.unit9'),
  i18n.t('HT.numberUnits.unit10'),
  i18n.t('HT.numberUnits.unit11'),
  i18n.t('HT.numberUnits.unit12'),
  i18n.t('HT.numberUnits.unit13'),
  i18n.t('HT.numberUnits.unit14'),
  i18n.t('HT.numberUnits.unit15'),
  i18n.t('HT.numberUnits.unit16'),
];

export default {
  YESTERDAY,
  SEVEN,
  THIRTY,
  YEAR
};
